/**
 * Ostoskorin modaalit: VAIN lemmikkimaksu.
 * Vaatii: modalManager (snippets/modal.liquid), JSON-data (#lemmikkimaksu-data)
 *
 * - Poistettu hinnan erittely kokonaan.
 * - Ei “värikoodauksia”, ei mitään turhaa.
 * - Turvallinen HTML-escape + JSON-parse.
 * - Click + Enter/Space toimii.
 */
(function () {
  'use strict';

  // ---------- Utilities ----------
  function escapeHtml(value) {
    const str = String(value == null ? '' : value);
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeJsonParseFromEl(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    const raw = (el.textContent || '').trim();
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      console.error('Virhe JSON-parsinnassa:', id, err);
      return null;
    }
  }

  function hasModalManager() {
    return !!(window.modalManager && typeof window.modalManager.open === 'function');
  }

  function openModal(title, html, fallbackText) {
    if (hasModalManager()) {
      window.modalManager.open(title, html);
      return;
    }
    // Kevyt fallback ilman alertia
    const w = window.open('', '_blank', 'noopener,noreferrer');
    if (!w) {
      console.log(title + ': ' + (fallbackText || ''));
      return;
    }
    w.document.title = title;
    w.document.body.style.margin = '16px';
    w.document.body.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
    w.document.body.innerHTML =
      '<h1 style="font-size:18px;margin:0 0 12px;">' + escapeHtml(title) + '</h1>' + html;
  }

  function shouldHandleKeyAsClick(e) {
    const key = e.key || e.code;
    return key === 'Enter' || key === ' ' || key === 'Spacebar';
  }

  // ---------- Lemmikkimaksu modal ----------
  class LemmikkimaksuModal {
    constructor() {
      this.data = null;
    }

    loadData() {
      return safeJsonParseFromEl('lemmikkimaksu-data');
    }

    getItemsToShow(data) {
      if (!data || !Array.isArray(data.items)) return [];
      return data.items.filter(function (i) {
        return Number((i && i.petFeeEur) || 0) > 0;
      });
    }

    getPlainTextFallback(items) {
      if (!items || !items.length) return 'Ei tietoja saatavilla.';
      return items
        .map(function (i) {
          return (i.productTitle || 'Tuote') + ': ' + Number(i.petFeeEur) + '€';
        })
        .join(' | ');
    }

    render(items) {
      if (!items.length) {
        return '<div class="p-py-lg text-center text-foreground text-base">Ei lemmikkimaksu-tietoja saatavilla.</div>';
      }

      let html = '';
      html += '<p class="text-sm  leading-relaxed text-foreground m-my-md">';
      html +=
        'Lemmikkimaksu veloitetaan erikseen majoituksen sisäänkirjautumisen yhteydessä. ' +
        'Maksulla katetaan ylimääräiset siivouskulut (esim. karvojen poisto huonekaluista).';
      html += '</p>';

      html +=
        '<div class="d-flex justify-between gap-lg p-py-md text-base font-medium text-foreground" ' +
        'style="border-top:1px solid #ebebeb;border-bottom:1px solid #ebebeb">';
      html += '<span>Majoitus</span><span>Lemmikkimaksu</span>';
      html += '</div>';

      html += items
        .map(function (item, index) {
          const title = escapeHtml(item.productTitle || 'Tuote');
          const rawDate =
            (item.dateDisplay && String(item.dateDisplay).trim()) ||
            (item.checkin && item.checkout
              ? String(item.checkin) + ' – ' + String(item.checkout)
              : '');
          const dates = rawDate
            ? '<span class="text-sm text-foreground">' + escapeHtml(rawDate) + '</span>'
            : '';

          const fee = Number(item.petFeeEur || 0);

          return (
            (index > 0 ? '<hr style="border:none;border-top:1px solid #ebebeb;margin:0" />' : '') +
            '<div class="d-flex justify-between items-center gap-lg p-py-md">' +
              '<div class="d-flex flex-col gap-xs">' +
                '<span class="text-sm text-foreground leading-snug">' + title + '</span>' +
                dates +
              '</div>' +
              '<span class="text-sm font-semibold text-foreground flex-shrink-0">' + fee + '€</span>' +
            '</div>'
          );
        })
        .join('');

      return html;
    }

    open() {
      this.data = this.loadData();
      const items = this.getItemsToShow(this.data);
      const content = this.render(items);
      openModal('Lemmikkimaksu', content, this.getPlainTextFallback(items));
    }
  }

  // ---------- Init ----------
  function init() {
    const lemmikkimaksuModal = new LemmikkimaksuModal();

    function isPetTrigger(el) {
      return !!(el && el.closest && el.closest('[data-modal="lemmikkimaksu"]'));
    }

    document.addEventListener('click', function (e) {
      if (isPetTrigger(e.target)) lemmikkimaksuModal.open();
    });

    document.addEventListener('keydown', function (e) {
      if (!shouldHandleKeyAsClick(e)) return;
      const t = e.target;
      if (isPetTrigger(t)) {
        e.preventDefault();
        lemmikkimaksuModal.open();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();